
import * as defaultImport from "@splunk/react-ui/Number";
export * from "@splunk/react-ui/Number";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
